export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-900">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-chat-smile-2-line text-white text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-white">吃瓜网51</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              吃瓜网51是国内领先的娱乐八卦与热点话题讨论平台，汇聚千万网友实时分享最新爆料和热门话题。加入吃瓜群众大本营，畅聊最新内幕。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-white hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-white hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-white hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-heading font-bold text-sm text-white mb-1">快速导航</h3>
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">首页</a>
            <a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">吃瓜热榜</a>
            <a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">话题广场</a>
            <a href="#updates" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">最新快讯</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">关于我们</a>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-heading font-bold text-sm text-white mb-1">热门话题</h3>
            <a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">明星八卦</a>
            <a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">影视综艺</a>
            <a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">社会热点</a>
            <a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">情感生活</a>
            <a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">搞笑趣闻</a>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-heading font-bold text-sm text-white mb-1">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。如有合作意向，欢迎通过爆料页面与我们联系。
            </p>
            <div className="mt-2">
              <p className="text-xs text-foreground-400">联系邮箱：baoliao@chigua51.com</p>
              <p className="text-xs text-foreground-400">客服热线：400-888-5151</p>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2020-2026 吃瓜网51 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">用户协议</a>
            <a href="#hero" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}